/**
 * Short text badge shown on a seat tile, e.g. Ryanair's "XL" on extra-legroom
 * rows. Configured per seat category:
 *
 *   theme: {
 *     premiumBadge: {
 *       labels: { 'Extra Legroom Seat': 'XL', 3: 'XL' },
 *       background: '#E9007D',
 *       textColor: '#FFFFFF',
 *     },
 *   }
 *
 * Categories can be keyed by display_name or by rank; rank is the stable one,
 * since display_name varies by carrier and locale.
 *
 * Opt-in: with no `labels` configured nothing renders, so this is inert for
 * every partner that has not asked for it.
 */
export const getPremiumBadgeLabel = (theme, seatCategory) => {
  const labels = theme?.premiumBadge?.labels;
  if (!labels || !seatCategory) return null;
  return labels[seatCategory.display_name] ?? labels[seatCategory.rank] ?? null;
};

export default getPremiumBadgeLabel;
